import api from '@/services/utils/apiInstance.ts';

import type { KycComplianceFlags, KycComplianceFlagsRequest } from '@/types/services/user/kycComplianceFlags.type.ts';

class KycComplianceFlagsService {
  // Partial update — only the fields present in `flags` are sent/overwritten. Triggers an LCB-FT
  // recompute server-side; callers should refresh the LCB-FT classification afterward (the
  // response shape of this endpoint isn't relied upon here).
  async update(userId: number, flags: Partial<KycComplianceFlags>): Promise<void> {
    const payload: KycComplianceFlagsRequest = {}

    if (flags.documentsInForeignLanguage !== undefined) {
      payload.documents_in_foreign_language = flags.documentsInForeignLanguage
    }
    if (flags.refusedToCommunicateInformation !== undefined) {
      payload.refused_to_communicate_information = flags.refusedToCommunicateInformation
    }
    if (flags.attitudeChangeDetected !== undefined) {
      payload.attitude_change_detected = flags.attitudeChangeDetected
    }
    if (flags.priorSuspiciousActivityReport !== undefined) {
      payload.prior_suspicious_activity_report = flags.priorSuspiciousActivityReport
    }

    await api.put(`/kyc-compliance-flags/${userId}`, payload)
  }
}

export default new KycComplianceFlagsService();
